export enum TreeSupplyCompany {
  FUTURE_FOREST_COMPANY = 'FUTURE_FOREST_COMPANY',
  INTERNATIONAL_TREE_FOUNDATION = 'INTERNATIONAL_TREE_FOUNDATION',
  PROTECT_EARTH = 'PROTECT_EARTH',
}
